/**
 * The Document Workspace opens through the EventBus, which goes nowhere unless a
 * `DocumentWorkspaceHost` is mounted on the current page. Hosts register here, so callers that
 * have an older fallback (the attachment card and its Forge viewer) can tell whether the event
 * will open a window.
 */
import { EventBus, DOCUMENT_EVENTS } from '@/event-bus';

let mountedHosts = 0;

export function registerWorkspaceHost() {
  mountedHosts += 1;
}

export function unregisterWorkspaceHost() {
  mountedHosts = Math.max(0, mountedHosts - 1);
}

/**
 * Opens the Document Workspace on the current page.
 * @param {{ documentId?: string, document?: object, revisionId?: string, tab?: string }} payload
 * @returns {boolean} false when no host is mounted, so nothing opened
 */
export function openDocumentWorkspace(payload) {
  if (mountedHosts === 0) return false;
  EventBus.$emit(DOCUMENT_EVENTS.OPEN_WORKSPACE, payload);
  return true;
}
